/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createFilter } from '../../factoriesAny.js';
export var filterDependencies = {
  typedDependencies,
  createFilter
};